export const data = [
  {
    category: "Front-End UI/UX Design",
    skills: [
      {
        skill: "Javascript",
        logo: require("../assets/images/skills/js.png"),
        rating: 4,
      },
      {
        skill: "React",
        logo: require("../assets/images/skills/react.png"),
        rating: 5,
      },
      {
        skill: "Redux",
        logo: require("../assets/images/skills/redux.png"),
        rating: 4,
      },
      {
        skill: "HTML",
        logo: require("../assets/images/skills/html5.png"),
        rating: 4,
      },
      {
        skill: "CSS",
        logo: require("../assets/images/skills/css3.png"),
        rating: 4,
      },
      {
        skill: "Next JS",
        logo: require("../assets/images/skills/nextjs.webp"),
        rating: 4,
      },
    ],
  },
  {
    category: "Back-End Development",
    skills: [
      {
        skill: "NodeJS",
        logo: require("../assets/images/skills/nodejs.png"),
        rating: 4,
      },
      {
        skill: "MongoDB",
        logo: require("../assets/images/skills/mongodb.png"),
        rating: 3,
      },
      {
        skill: "Typescript",
        logo: require("../assets/images/skills/typescript.png"),
        rating: 3,
      },
      {
        skill: "GraphQL",
        logo: require("../assets/images/skills/graphql.png"),
        rating: 2,
      },
    ],
  },
  {
    category: "DevOps and Cloud",
    skills: [
      {
        skill: "Docker",
        logo: require("../assets/images/skills/docker.png"),
        rating: 2,
      },
      {
        skill: "AWS",
        logo: require("../assets/images/skills/aws.png"),
        rating: 2,
      },
      {
        skill: "Netlify",
        logo: require("../assets/images/skills/netlify.png"),
        rating: 3,
      },
      {
        skill: "Heroku",
        logo: require("../assets/images/skills/heroku.png"),
        rating: 3,
      },
    ],
  },
  {
    category: "Other Development Tools",
    skills: [
      {
        skill: "Postman",
        logo: require("../assets/images/skills/postman.png"),
        rating: 3,
      },
      {
        skill: "Github",
        logo: require("../assets/images/logos/github.png"),
        rating: 5,
      },
      {
        skill: "Gitlab",
        logo: require("../assets/images/skills/gitlab.png"),
        rating: 4,
      },
      {
        skill: "Jira",
        logo: require("../assets/images/skills/jira.png"),
        rating: 3,
      },
    ],
  },
];
